import React, { useEffect, useState } from "react";
import { Row, Col, Radio, Tooltip, TablePaginationConfig, RadioChangeEvent, Button, Input, message } from 'antd';
import './home.less';
import { BarChart } from "./echarts/BarChart";
import Table, { ColumnsType } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, getBaseImgLookUrl } from "@src/utils/constants";
import { ISearchPage } from "@src/types/FmsTypes";
import { IMdNoticeDetail, IMdNoticeFields } from "../authPortal/notice/NoticeTypes";
import { IAppUsage, IMdLogDetail, IOneLineFields } from "../authPortal/log/LogTypes";
import YhNotice from "@src/components/YhNotice";
import { logService } from "../authPortal/log/LogService";
import useGlobalModel from "@src/model/globalModel";
import { IMdAppDetail } from "../authPortal/app/AppTypes";
import { openWin } from "@src/utils/ipc-client";
import { transPgToPagination } from "@src/utils/utils";
import { noticeService } from "../authPortal/notice/NoticeService";
import moment from "moment";
import FontIcon from "@src/components/YhIcon";
import { SyncOutlined } from "@ant-design/icons";
// import { IMdLogDetail } from "../authPortal/log/LogTypes";
// interface ChartDataProps {
//     value: number;
//     name: string;
//     color?: string;
// }

enum TimeTypeEnum {
    today,
    month,
    year,
}

export function Home() {
    const {
        user,
        menuData
    } = useGlobalModel()
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [logPgCfg, setLogPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IMdNoticeDetail>();
    const [onLineUsers, setOnleUsers] = useState<IOneLineFields>({ userOnline: 0, userTotal: 0 })
    const [userApps, setUserApps] = useState<IMdAppDetail[]>([])

    const [mode, setMode] = useState('2')
    const [chartData, setChartData] = useState<IAppUsage[]>([])


    const [dataSource, setDataSource] = useState<IMdLogDetail[]>([]) // 出入库

    const [noticeLoading, setNoticeLoading] = useState(false)
    const [noticeDataSource, setNoticeDataSource] = useState<IMdNoticeDetail[]>([]) // 出入库


    const handleModeChange = (e: RadioChangeEvent) => {
        const mode = e.target.value
        // console.log(mode)
        setMode(mode)
        initAppsUsage(mode)
    }

    /** 查询在线人数 */
    const initOnleUsers = async () => {
        try {
            const { retData } = await logService.onLineUser()
            setOnleUsers(retData)
        } catch (error) {
            console.log("在线人数查询失败：", error)
        }
    }

    /** 查询当前用户可访问app */
    const initUserApps = async () => {
        try {
            const { retData } = await logService.showUserApp(user.userCode as string)
            setUserApps(retData.filter(item => item.code !== "portal" && item.enable === 1).sort((a, b) => (a.orderNum ?? 0) - (b.orderNum ?? 1)))
        } catch (error) {
            console.log("用户可访问app查询失败：", error)
        }
    }

    /** 查询当前用户可访问app */
    const initLoginLog = async (page?: ISearchPage) => {
        try {
            const searchParams = {
                page: {
                    pageSize: page?.pageSize ?? logPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: page?.pageNum ?? logPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                }
            }
            const { retData } = await logService.page(searchParams);
            const { records, ...pg } = retData;

            setLogPgCfg(transPgToPagination(pg));
            setDataSource(records);

        } catch (error) {
            console.log("用户可访问app查询失败：", error)
        }
    }

    /** 查询app访问记录 */
    const initAppsUsage = async (modeType?: string) => {
        try {
            let retData = [] as IAppUsage[]
            switch (modeType ?? mode) {
                case '1':
                    retData = await (await logService.appUsageToday()).retData
                    break;
                case '2':
                    retData = await (await logService.appUsageWeek()).retData
                    break;
                case '3':
                    retData = await (await logService.appUsageMouth()).retData
                    break;
                case '4':
                    retData = await (await logService.appUsageYear()).retData
                    break;
                default:
                    break;
            }
            setChartData(() => retData.map((item) => ({ ...item, usePercent: item.usePercent > 1 ? 1 : item.usePercent })))
            // console.log('appUsage: ', retData)
        } catch (error) {
            console.log("用户可访问app查询失败：", error)
        }
    }

    const [noticeSearch, setNoticeSearch] = useState<string>("");

    /** 查询通知公告 */
    const loadNoticeData = async (page?: ISearchPage) => {
        try {
            setNoticeLoading(true)
            setSelectedData(undefined)
            setSelectedRowKeys([])
            const searchParams = {
                userCode: user.userCode,
                title: noticeSearch === "" ? undefined : noticeSearch,
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                }
            }
            let { retData } = await noticeService.pageUser(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            // setSelectedRowKeys([records[0].id as React.Key])
            // setSelectedData(records[0])
            setNoticeDataSource(records);
        } catch (error) {
            console.log(error)
        } finally {
            setNoticeLoading(false)
        }
    }

    const columns: ColumnsType<IMdLogDetail> = [{
        title: '用户姓名',
        dataIndex: 'userName',
        key: 'userName',
        width: 120,
        ellipsis: true,
        align: 'center'
    }, {
        title: '账号',
        dataIndex: 'userCode',
        key: 'userCode',
        width: 100,
        ellipsis: true,
        align: 'center'
    }, {
        title: '操作时间',
        dataIndex: 'loginTime',
        key: 'loginTime',
        width: 160,
        align: 'center'
    }, {
        title: 'IP',
        dataIndex: 'ip',
        key: 'ip',
        width: 80,
        ellipsis: true,
        align: 'center'
    }, {
        title: '状态',
        dataIndex: 'loginStatus',
        key: 'loginStatus',
        width: 60,
        align: 'center'
    }];

    const noticeColumns: ColumnsType<IMdNoticeDetail> = [{
        title: '公告标题',
        dataIndex: 'title',
        key: 'title',
        // width: 200,
        ellipsis: true,
        align: 'center'
    }, {
        title: '公告类型',
        dataIndex: 'noticeTypeName',
        key: 'noticeTypeName',
        width: 80,
        align: 'center',
        ellipsis: true
    }, {
        title: '接收时间',
        dataIndex: 'pubTime',
        key: 'pubTime',
        width: 180,
        align: 'center',
        render: (dateArray) => dateArray ? moment([
            dateArray[0],
            dateArray[1] - 1, // 将月份减1，使5→4（代表5月）
            dateArray[2],
            dateArray[3],
            dateArray[4],
            dateArray[5]
        ]).format("YYYY-MM-DD HH:mm:ss") : ''
    }, {
        title: '公告状态',
        dataIndex: 'readFlag',
        key: 'readFlag',
        width: 80,
        align: 'center',
        render: (v) => v ? '已读' : '未读'
    }];


    const readNotice = async (id: string) => {
        const data = noticeDataSource.map(item => {
            if (item.id === id) {
                item.read = item?.read ? item?.read + 1 : 1
                item.unRead = item?.unRead ? item?.unRead - 1 : 0
                item.readFlag = true
                setSelectedData(item)
            }
            return item
        })
        setNoticeDataSource(data)
        try {
            const { userCode } = user
            const { retMsg, success } = await noticeService.readNotice(id, userCode as string)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        initOnleUsers()
        initUserApps()
        initAppsUsage()
        initLoginLog()
        // initStatistics()
        // selectAccount()
        // selectTable()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        loadNoticeData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setSelectedRowKeys])

    //门户集成传过去token
    const applicationJump = (url: string, appCode: string, appType: string) => {
        if (process.env.REACT_APP_ENV === "TEST" && url.indexOf("yunhaogroup") !== -1) {
            message.error("当前测试门户链接至生产地址，请联系后台人员修改")
            return false;
        }
        url = url + `?token=${user.token}&appCode=${appCode}&appType=${appType}&r=${Math.random()}`;
        openWin(appCode, url)
    }

    return (
        <div className={`flex-column home-content ${menuData.length > 1 ? "" : "home-content__lage"}`}>
            {/* 上半部分 */}
            <div className="flex home-content-layout">
                <Row gutter={16}>
                    {/* 综合模块 */}
                    <Col span={16} className="flex-column flex-1">
                        <div className="home-content-item">
                            <div className="flex items-center justify-between item-header">
                                <div className="flex items-center item-header-left">
                                    <div className="item-header-line"></div>
                                    <div className="item-header-title">用户统计</div>
                                </div>

                            </div>
                            <div className="flex items-center justify-center item-content-progress">
                                <span className="label">当前用户数量</span>
                                <div style={{ height: '10px', borderRadius: '5px', flex: 1, display: 'flex', background: '#E5E5E5' }}>
                                    <Tooltip
                                        color="#fff"
                                        title={
                                            <div className="flex items-center justify-center" style={{ color: "#010101", fontSize: "14px", padding: "0 20px" }}>
                                                <span>当前在线人数</span>
                                                <span style={{ color: "#029CFF", fontSize: "20px", marginLeft: "4px" }}>{onLineUsers.userOnline}人</span>
                                            </div>
                                        }>
                                        <div style={{ borderRadius: '5px', background: 'linear-gradient(90deg, #7FD4FC, #4C52C1)', height: '10px', width: `${Math.round(onLineUsers.userOnline / onLineUsers.userTotal * 100)}%` }}></div>
                                    </Tooltip>
                                </div>
                                <span className="value">{onLineUsers.userTotal}人</span>
                            </div>
                        </div>
                        <Row gutter={16} className="flex-1 home-content-layout">
                            <Col span={selectedRowKeys.length === 0 ? 24 : 16} className="flex-column flex-1">
                                <div className="flex-1 home-content-item">
                                    <div className="flex items-center justify-between item-header">
                                        <div className="flex items-center item-header-left">
                                            <div className="item-header-line"></div>
                                            <div className="item-header-title">通知公告</div>
                                        </div>
                                        <div className="flex items-center">
                                            <Input
                                                allowClear
                                                size="small"
                                                datatype="round"
                                                className="mr-10"
                                                placeholder="公告标题"
                                                style={{ width: "120px", borderRadius: "20px" }}
                                                value={noticeSearch}
                                                onChange={(e) => setNoticeSearch(e.target.value)}
                                                onPressEnter={() => loadNoticeData({ pageNum: 1 })}
                                            />
                                            <SyncOutlined className="pointer" spin={noticeLoading} onClick={() => loadNoticeData()} />
                                        </div>
                                    </div>
                                    <div className="flex item-content">
                                        <Table
                                            rowKey={record => record.id ?? record.key}
                                            loading={noticeLoading}
                                            dataSource={noticeDataSource}
                                            columns={noticeColumns}
                                            rowSelection={{
                                                type: "radio",
                                                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdNoticeDetail[]) => {
                                                    setSelectedRowKeys(selectedRowKeys);
                                                    if (selectedRowKeys.length !== 0 && selectedRows[0].readFlag === false) {
                                                        readNotice(selectedRows[0].id as string)
                                                    } else {
                                                        setSelectedData(selectedRows[0])
                                                    }
                                                },
                                                selectedRowKeys
                                            }}
                                            onRow={record => {
                                                return {
                                                    onClick: event => {
                                                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                                                            setSelectedRowKeys([]);
                                                            setSelectedData(undefined)
                                                        } else {
                                                            setSelectedRowKeys([record.id as string]);
                                                            if (record.readFlag === false) {
                                                                readNotice(record.id as string)
                                                            } else {
                                                                setSelectedData(record)
                                                            }
                                                        }
                                                    },
                                                };
                                            }}
                                            pagination={{
                                                ...pgCfg,
                                                position: ["bottomCenter"],
                                                onChange: (pageNum, pageSize) => {
                                                    loadNoticeData({ pageNum, pageSize }).then();
                                                }
                                            }}
                                            scroll={{ y: '220px' }}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={8} className="flex-column flex-1" hidden={selectedRowKeys.length === 0}>
                                <div className="flex-1 home-content-item notice-item">
                                    <div className="notice-item-arrow"></div>
                                    <YhNotice content={selectedData as IMdNoticeFields} height="380px" />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {/* 应用模块 */}
                    <Col span={8} className="flex-column flex-1">
                        <div className="flex-1 home-content-item">
                            <div className="flex items-center justify-between item-header">
                                <div className="flex items-center item-header-left">
                                    <div className="item-header-line"></div>
                                    <div className="item-header-title">我的应用</div>
                                </div>
                            </div>
                            <Row className="flex item-content">
                                {
                                    userApps.map(item => (
                                        <Col span={6} className="app-item" onClick={() => applicationJump(item.appUrl as string, item.code as string, item.appTypeCode as string)} key={item.key}>
                                            <div className="app-item-icon">
                                                <img src={getBaseImgLookUrl(item.iconUrl as string)} alt="" />
                                            </div>
                                            <div>{item.name}</div>
                                        </Col>
                                    ))
                                }
                                {/* <Col span={4} className="flex-column items-center app-item">
                                    <img src="http://api-cs.laoniuche.cn/auth/file/fetch?id=9ac8197948514b99a1080e1a35f2bbc0" alt="" />
                                    <div>主数据1.0</div>
                                </Col>
                                <Col span={4} className="app-item">
                                    <img src="http://api-cs.laoniuche.cn/auth/file/fetch?id=e10925a4f0e54ef48627316e90c37c7f" alt="" />
                                    <div>主数据1.0</div>
                                </Col> */}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* 下半部分 */}
            <div className="flex home-content-layout">
                <Row gutter={16}>
                    {/* 应用统计模块 */}
                    <Col span={16} className="flex-column flex-1">
                        <div className="home-content-item flex-1">
                            <div className="flex items-center justify-between item-header">
                                <div className="flex items-center item-header-left">
                                    <div className="item-header-line"></div>
                                    <div className="item-header-title">各应用系统使用统计图</div>
                                </div>
                                <Radio.Group onChange={handleModeChange} value={mode} buttonStyle="solid">
                                    <Radio.Button className="item-header-radio" value="1">本日</Radio.Button>
                                    <Radio.Button className="item-header-radio" value="2">本周</Radio.Button>
                                    <Radio.Button className="item-header-radio" value="3">本月</Radio.Button>
                                    <Radio.Button className="item-header-radio" value="4">本年</Radio.Button>
                                </Radio.Group>
                            </div>
                            <div className="flex item-content" style={{ height: "calc(100% - 70px)" }}>
                                <div className="flex-1">
                                    <BarChart
                                        xData={chartData.map(item => item.appName)}
                                        yData={[
                                            chartData.map(item => item.userNumber),
                                            chartData.map(item => Number((item.usePercent * 100).toFixed(2)))]}
                                        legendData={['使用人数', '使用频率']}
                                        color={['#C490BF', '#B3D465']}
                                        formatter={`
                                            <span style="color: #010101">
                                                {b}
                                            <span><br />
                                            <span style="color: #C490BF">
                                                使用人数：{c0}人
                                            <span><br/>
                                            <span style="color: #6E9B03">
                                                使用频率：{c1}%
                                            </span>
                                        `}
                                    // formatter={(params: any[], ticket: string) => {
                                    //     let { value: value1, name } = params[0];  //bar
                                    //     let { value: value2 } = params[1];  //line
                                    //     console.log(params, ticket); return `
                                    //      <span style="color: #010101">
                                    //          ${name}
                                    //      <span><br />
                                    //      <span style="color: #C490BF">
                                    //          使用人数：${value1 ?? 0}人
                                    //      <span><br/>
                                    //      <span style="color: #6E9B03">
                                    //          使用频率：${(value2 ?? 0) > 1 ? 1 : value2}%
                                    //      </span>
                                    //  ` }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* 登录日志模块 */}
                    <Col span={8} className="flex-column flex-1">
                        <div className="flex-1 home-content-item">
                            <div className="flex items-center justify-between item-header">
                                <div className="flex items-center item-header-left">
                                    <div className="item-header-line"></div>
                                    <div className="item-header-title">登录日志</div>
                                </div>
                            </div>
                            <Table rowKey={record => record.id ?? record.key} dataSource={dataSource} columns={columns} pagination={false} scroll={{ y: '200px' }} />
                        </div>
                    </Col>
                </Row>
            </div>
        </div >
    )
}
